import React from 'react'
import SliderMissionVision from '../../component/slidercomponent/SliderMissionVision'

const MissionVision = () => {
    return (
        <>
            <div className='page-wraper -bar-wrapper' style={{ overflow: "hidden", marginTop: "-110px" }}>
                <section className="services-one">
                    <div className="services-one_pattern" style={{ backgroundImage: 'url(assets/images/background/pattern-2.png)' }} />
                    <div className="services-one_pattern-two" style={{ backgroundImage: 'url(assets/images/background/pattern-3.png)' }} />
                    <div className="auto-container">
                        <div className=" owl-carousel owl-theme owl-loaded owl-drag" style={{ overflow: "hidden", marginTop: "-70px" }}>
                            <SliderMissionVision />

                            {/* <div className="owl-stage-outer">
                                <div className="owl-stage" style={{ transform: 'translate3d(-1200px, 0px, 0px)', transition: 'all', width: 4800 }}>

                                    <div className="owl-item cloned" style={{ width: 350, marginRight: 30 }}>
                                        <div className="service-block">
                                            <div className="service-block_inner">
                                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                                <span className="service-block_icon flaticon-examining-table" />
                                                <h4 className="service-block_heading"><a to="intensive-care.html">Holter Monitoring</a></h4>
                                                <div className="service-block_text">Dicta explicabo. Nemo enim ipsam voluptatem quia voluptas.</div>
                                                <a className="service-block-more" to="intensive-care.html">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item active" style={{ width: 350, marginRight: 30 }}>
                                        <div className="service-block">
                                            <div className="service-block_inner">
                                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                                <span className="service-block_icon flaticon-examining-table" />
                                                <h4 className="service-block_heading"><a to="intensive-care.html">Holter Monitoring</a></h4>
                                                <div className="service-block_text">Dicta explicabo. Nemo enim ipsam voluptatem quia voluptas.</div>
                                                <a className="service-block-more" to="intensive-care.html">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item active" style={{ width: 350, marginRight: 30 }}>
                                        <div className="service-block">
                                            <div className="service-block_inner">
                                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                                <span className="service-block_icon flaticon-mri" />
                                                <h4 className="service-block_heading"><a to="intensive-care.html">MRI Scan and Imaging</a></h4>
                                                <div className="service-block_text">Dicta explicabo. Nemo enim ipsam voluptatem quia voluptas.</div>
                                                <a className="service-block-more" to="intensive-care.html">Read More</a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="owl-item" style={{ width: 350, marginRight: 30 }}>
                                        <div className="service-block">
                                            <div className="service-block_inner">
                                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                                <span className="service-block_icon flaticon-examining-table" />
                                                <h4 className="service-block_heading"><a to="intensive-care.html">Holter Monitoring</a></h4>
                                                <div className="service-block_text">Dicta explicabo. Nemo enim ipsam voluptatem quia voluptas.</div>
                                                <a className="service-block-more" to="intensive-care.html">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item" style={{ width: 350, marginRight: 30 }}>
                                        <div className="service-block">
                                            <div className="service-block_inner">
                                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                                <span className="service-block_icon flaticon-mri" />
                                                <h4 className="service-block_heading"><a to="intensive-care.html">MRI Scan and Imaging</a></h4>
                                                <div className="service-block_text">Dicta explicabo. Nemo enim ipsam voluptatem quia voluptas.</div>
                                                <a className="service-block-more" to="intensive-care.html">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="owl-item" style={{ width: 350, marginRight: 30 }}>
                                        <div className="service-block">
                                            <div className="service-block_inner">
                                                <div className="service-one_smog-layer" style={{ backgroundImage: 'url(assets/images/background/pattern-4.png)' }} />
                                                <span className="service-block_icon flaticon-dentist-chair" />
                                                <h4 className="service-block_heading"><a to="intensive-care.html">Express Blood Tests</a></h4>
                                                <div className="service-block_text">Dicta explicabo. Nemo enim ipsam voluptatem quia voluptas.</div>
                                                <a className="service-block-more" to="intensive-care.html">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </section>


                <section className="services-section-two" style={{marginTop:"-115px"}}>
                    <div className="section-text variable-text"><i className="ti-placeholder" style={{ display: 'inline-block', width: 0, lineHeight: 0, overflow: 'hidden' }}>.</i><span style={{ display: 'inline', position: 'relative', font: 'inherit', color: 'inherit' }} className="ti-container">M</span><span style={{ display: 'inline', position: 'relative', font: 'inherit', color: 'inherit', opacity: '0.91354' }} className="ti-cursor">|</span></div>
                    <div className="auto-container">
                        <div className="row clearfix" style={{ marginTop: "-60px" }}>
                            {/* <div className="title-column col-lg-12 col-md-12 col-sm-12">
                                <div className="inner-column">
                                    <div className="sec-title">
                                        <h2 style={{ textAlign: "center" }} className="sec-title_heading">Mission & Vision</h2>
                                    </div>
                                </div>
                            </div> */}
                            <div className="blocks-column col-lg-12 col-md-12 col-sm-12">
                                <div className="inner-column">
                                    <div className="row clearfix">
                                        <div className="service-block-two col-lg-6 col-md-6 col-sm-12">
                                            <div className="inner-box">
                                                <div className="number-box">
                                                    <div className="number">01</div>
                                                </div>
                                                <h4><a to="#">Mission</a></h4>
                                                <div className="text">To provide everyone in our community with high-quality, compassionate treatment at all times in order to improve their health.
                                                    Our goal is to use a holistic medical approach to diagnose, treat, heal, educate, and assist humanity in achieving a healthy future.</div>
                                            </div>
                                        </div>
                                        <div className="service-block-two col-lg-6 col-md-6 col-sm-12">
                                            <div className="inner-box">
                                                <div className="number-box">
                                                    <div className="number">02</div>
                                                </div>
                                                <h4><a to="#">Vision</a></h4>
                                                <div className="text">To be a dynamic, growth-oriented company where people work together to overcome obstacles and attain excellence in all areas.
                                                    to give patients high-quality medical care while upholding moral and scientific principles. to continuously improve the hospital's medical education and practice. To establish the greatest standards in patient care, medical education, training, and research as a teaching hospital of distinction.

                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="service-block-two col-lg-4 col-md-6 col-sm-12">
                                            <div className="inner-box">
                                                <div className="number-box">
                                                    <div className="number">03</div>
                                                </div>
                                                <h4><a to="#">Values</a></h4>
                                                <div className="text">Replenish him third creature and meat blessed void a fruit gathered you’re behold had seed.</div>
                                            </div>
                                        </div> */}
                                        {/* <div className="service-block-two col-lg-12 col-md-12 col-sm-12">
                                            <div className="inner-box">
                                                <div className="number-box">
                                                    <div className="number">03</div>
                                                </div>
                                                <h4><a to="#">Diagnostic Center</a></h4>
                                                <div className="text">Replenish him third creature and meat blessed void a fruit gathered you’re behold had seed.</div>
                                            </div>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>


        </>
    )
}

export default MissionVision